import React, { useState, useEffect, useMemo } from 'react';
import { Button } from 'reactstrap';
import { useDispatch } from 'react-redux';
import { deleteChapterRequest, updateChapterRequest } from 'store/actions';
import CreateChapter from './CreateChapter';
import ConfirmationModal from 'components/Modals/ConfirmationModal';
import { MdDeleteOutline } from 'react-icons/md';
import { FaRegEdit } from 'react-icons/fa';
import Cookies from 'js-cookie';
import ChapterDataTable from 'components/TableContainers/ChapterDataTable';

const ChapterTable = ({ chapters, loading, totalrows, modules,courseOptions }) => {
  const dispatch = useDispatch();
  const [isOpen, setIsOpen] = useState(false);
  const [editData, setEditData] = useState(null);
  const [deleteId, setDeleteId] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [confirmAction, setConfirmAction] = useState(false);

  const [selectedSortData, setSelectedSortData] = useState({ value: 'createdAt', direction: 'desc' });
  const [pageIndex, setPageIndex] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [searchString, setSearchString] = useState('');

  const permissions = JSON.parse(localStorage.getItem('permissions'));
  const hasEditPermission = permissions?.some(item => item?.permission_name === 'Edit Chapter');
  const hasDeletePermission = permissions?.some(item => item?.permission_name === 'Delete Chapter');

  useEffect(() => {
    if (deleteId && confirmAction) {
      dispatch(deleteChapterRequest(deleteId));
      setOpenModal(false);
      setConfirmAction(false);
    }
  }, [confirmAction, deleteId, dispatch]);

  const columns = useMemo(() => [
    {
      header: 'Title',
      accessorKey: 'title',
    },
    {
      header: 'Order',
      accessorKey: 'orderIndex',
    },
    {
      header: 'Module',
      accessorKey: 'moduleId.title',
      showFilter: false,
      cell: ({ row }) => <span>{row.original?.moduleId?.title || '-'}</span>,
    },
    ...(hasEditPermission || hasDeletePermission
      ? [{
          header: 'Actions',
          id: 'actions',
          cell: ({ row }) => {
            const handleEdit = () => {
              setEditData(row.original);
              setIsOpen(true);
            };
            const handleDelete = () => {
              setDeleteId(row.original._id);
              setOpenModal(true);
            };
            return (
              <div className="d-flex gap-2">
                {hasEditPermission && (
                  <Button color="primary" onClick={handleEdit} title="Edit">
                    <FaRegEdit size={18} />
                  </Button>
                )}
                {hasDeletePermission && (
                  <Button color="danger" onClick={handleDelete} title="Delete">
                    <MdDeleteOutline size={18} />
                  </Button>
                )}
              </div>
            );
          }
        }]
      : [])
  ], [hasEditPermission, hasDeletePermission]);

  const handleFormSubmit = (id, data, onClose) => {
    dispatch(updateChapterRequest(id, data, onClose));
  };

  return (
    <>
      <ConfirmationModal
        okText="Confirm"
        onCancel={() => setOpenModal(false)}
        onOk={() => setConfirmAction(true)}
        isVisible={openModal}
        title="Delete Chapter"
        content="Are you sure you want to delete this chapter?"
      />

      <CreateChapter
        visible={isOpen}
        initialData={editData}
        onSubmit={handleFormSubmit}
        handleClose={() => setIsOpen(false)}
        courseOptions={courseOptions}
      />

      <div className="container-fluid">
        <ChapterDataTable
          columns={columns}
          loading={loading}
          data={chapters || []}
          courseOptions={courseOptions}
          isGlobalFilter
          isPagination
          selectedSortData={selectedSortData}
          setSelectedSortData={setSelectedSortData}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
          setPageSize={setPageSize}
          pageSize={pageSize}
          setSearchString={setSearchString}
          searchString={searchString}
          SearchPlaceholder="Search chapters..."
          pagination="pagination"
          docName="Chapters"
          totalrows={totalrows}
          paginationWrapper="dataTables_paginate paging_simple_numbers"
          tableClass="table-bordered table-nowrap dt-responsive nowrap w-100 dataTable no-footer dtr-inline"
        />
      </div>
    </>
  );
};

export default ChapterTable;
